// removed by extract-text-webpack-plugin
module.exports = {"column":"src-components-column----column-module---column---1gShU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/column/column.module.pcss
// module id = 297
// module chunks = 104033720589488